export default __webpack_public_path__ + "static/media/mepbackgroundc3.0294edf6.jpg";